import { useEffect, useState } from 'react';
import type { FormEvent } from 'react';
import { api, errorText } from '../api';
import { useAuth } from '../auth';
import { Notice } from '../components/ui';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [mandant, setMandant] = useState('');

  // Welcher Mandant hinter dieser Subdomain steckt - für die Anzeige oben.
  useEffect(() => {
    api<{ mandant: string | null }>('/api/auth/instanz')
      .then((r) => setMandant(r.mandant ?? ''))
      .catch(() => setMandant(''));
  }, []);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await login(email, password);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="anmeldeseite">
      <main className="anmelde-spalte">
        <div className="anmelde-inhalt">
          <div className="anmelde-mandant">{mandant || 'K&G Media'}</div>

          {error && <Notice kind="error">{error}</Notice>}

          <form className="anmelde-card" onSubmit={submit}>
            <h2>
              Melde dich in deiner<br />
              Warenwirtschaft an
            </h2>

            <label className="anmelde-feld">
              Benutzername oder E-Mail
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                autoCapitalize="none"
                spellCheck={false}
                required
                autoFocus
              />
            </label>

            <label className="anmelde-feld">
              Passwort
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </label>

            <p className="klein anmelde-hinweis">Passwort vergessen? Ein Administrator setzt es zurück.</p>

            <button type="submit" className="primary breit" disabled={busy}>
              {busy ? 'Anmeldung läuft …' : 'Anmelden'}
            </button>
          </form>

          <p className="klein zentriert anmelde-sperrnote">
            Nach mehreren Fehlversuchen wird der Zugang vorübergehend gesperrt.
          </p>
          <footer className="anmelde-fuss klein">Logistik-WaWi</footer>
        </div>
      </main>

      <aside className="marken-spalte">
        <div className="marken-mitte">
          <div className="marken-zeichen mit-logo">
            <img src="/kg-media.svg" alt="" />
          </div>
          <div className="marken-name">Logistik-WaWi</div>
          <p className="marken-spruch">Warenwirtschaft &amp; Lagerverwaltung</p>
        </div>
        <div className="marken-fuss">
          <span className="marken-recht">© {new Date().getFullYear()} K&amp;G Media</span>
        </div>
      </aside>
    </div>
  );
}
